var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEhIconMedications = function SvgEhIconMedications(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 28
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10.6h5.95c.468 0 .85.383.85.85 0 .468-.382.85-.85.85H2.5v3.4h5.95c.468 0 .85.383.85.85 0 .468-.382.85-.85.85H2.5v3.4h5.95c.468 0 .85.383.85.85 0 .468-.382.85-.85.85H2.5v1.7c0 1.87 1.53 3.4 3.4 3.4h10.2c1.87 0 3.4-1.53 3.4-3.4v-17h-17zM19.925.4H2.075C1.371.4.8.971.8 1.675v2.55C.8 4.93 1.371 5.5 2.075 5.5h17.85c.704 0 1.275-.57 1.275-1.275v-2.55C21.2.971 20.629.4 19.925.4"
  })));
};
export default SvgEhIconMedications;